var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 6.96126C10.2188 6.96088 10.4355 7.00375 10.6378 7.08741C10.84 7.17107 11.0237 7.29387 11.1783 7.44876L15.5891 11.8604L14.4108 13.0388L9.99994 8.62792L5.58911 13.0388L4.41078 11.8604L8.82161 7.44959C8.97615 7.29456 9.15981 7.1716 9.36203 7.08779C9.56425 7.00399 9.78105 6.96098 9.99994 6.96126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.3f42dc1bd61ea93d0bc34fcf24676934.svg";
export { ForwardRef as ReactComponent };